import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { last } from 'lib/array/arrayUtils'
import { rem } from 'polished'
import styled from 'styled-components'
import Image from 'components/Common/Image'
import Label from 'LuxKit/Label'
import { useIntl } from 'react-intl'

const AirlineLogoImage = styled(Image)`
  height: ${rem(20)};
  width: auto;
`

interface Props {
  flights: Array<App.JourneyV2>
}

function FareFamilySelectModalReturnFareHeaderItem({
  flights,
}: Props) {
  const intl = useIntl()
  const brandMark = flights[0]?.carrierBrandMark
  const carrierName = flights[0]?.carrierName

  return <Group data-testid="fare-family-header-item" direction="vertical" tabletDirection="horizontal" verticalAlign="center" gap="8 0" tabletGap="0 8">
    <Group direction="horizontal" verticalAlign="center" gap="0 8">
      <BodyText variant="medium" colour="light-foreground-alt" weight="bold">
        {intl.formatMessage({
          id: '6iKTx9RINwXZTP7ee1UQ',
          defaultMessage: 'Return flight',
          description: 'Header label for return flight fare family selection',
        })}
      </BodyText>

      {brandMark && (
        <AirlineLogoImage
          image={{ url: brandMark }}
        />
      )}

      <BodyText variant="medium" colour="light-foreground-alt">{carrierName}</BodyText>
    </Group>

    <Group direction="horizontal" verticalAlign="center" gap="0 4">
      {flights.map(flight => (
        <Label key={flight.id} variant="ghost" kind="tertiary">
          {intl.formatMessage(
            {
              id: 'r5MTH6VFf8WlCBPZctxJ',
              defaultMessage: '{departure} — {arrival}',
              description: 'Flight route showing departure and arrival airport codes in return fare header',
            },
            { departure: flight.flightGroup.flights[0].departureAirport, arrival: last(flight.flightGroup.flights).arrivalAirport },
          )}
        </Label>
      ))}
    </Group>
  </Group>
}

export default FareFamilySelectModalReturnFareHeaderItem
